module.exports = __webpack_public_path__ + "static/media/Sector4.c2aa0f9f.jpg";